// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JnEE","importantInfo":"styles_importantInfo__9NDNx"};